export const defaultSettings = {
    features: {
        progressbar : false,
        centered: false,
        card: false
    },
    hidden_fields: {
    },
    theme : {
        dark: false,
        screen:{
          title: true,
          title_main: false,
          text: false
        },
        colors : {
            primary : "#027BE3",
            secondary : "#26A69A",
            dark: "#1d1d1d",
            darkPage: "#121212"
        },
        input : {
            label: false,
            sublabel: true,
            description: true,
            dense: true,
            filled: false,
            outlined: true,
            standout: false,
            borderless: false,
            rounded: false,
            square: false
        },
        button : {
            flat: false,
            rounded: false,
            round: false,
            outline: false,
            push: false,
            unelevated: false,
            noCaps: false,
            glossy: false,
            cs: false,
            colors : {
                primary : null,
                border : null,
                hover: null,
                hover_border: null,
                text: null,
                text_hover: null,
                active: null
            },
            size: "md"
        },
        next : {
            cs: false,
            colors : {
                primary : null,
                border : null,
                hover: null,
                hover_border: null,
                text: null,
                text_hover: null,
            },
            size: "md"
        },
        back : {
            cs: false,
            colors : {
                primary : null,
                border : null,
                hover: null,
                hover_border: null,
                text: null,
                text_hover: null,
            },
            size: "md"
        }
    }
}